import { UuidIdGenerator } from '../../../common'
import { User, UserStatus } from './users'
import { faker } from '@faker-js/faker/locale/ru'

export function mockUser(opts?: Partial<User>): User {
  const idGenerator = new UuidIdGenerator()
  const sex = faker.person.sexType()
  const name = faker.person.firstName(sex)
  const surname = faker.person.lastName(sex)
  return {
    id: idGenerator.generate(),
    email: faker.internet.email({ firstName: name, lastName: surname }),
    passwordHash: 'password',
    controlQuestionId: idGenerator.generate(),
    controlAnswerHash: 'answer',
    name: name,
    surname: surname,
    patronymic: faker.person.middleName(sex),
    municipalEntityId: idGenerator.generate(),
    phone: '7' + faker.phone.number().replaceAll(/[+ ()-]/g, ''),
    roleId: idGenerator.generate(),
    status: [UserStatus.ACTIVE, UserStatus.BLOCKED][Math.floor(Math.random() * 2)],
    createdAt: new Date(),
    cardIssuePointId: idGenerator.generate(),
    ...opts,
  }
}
